import CustomLayout from '@/common/Layout';
import React from 'react';
import MyHoldRequestsPage from './components/list';

function MyHoldRequests() {
  return (
    <CustomLayout sider={true} tracker={true}>
      <MyHoldRequestsPage />
    </CustomLayout>
  );
}

export default MyHoldRequests;
